import { IDocument } from 'prismic-reactjs';

export default function (_doc: IDocument) {
  return `/`;
}
